export default __webpack_public_path__ + "static/media/frontpage.678b5dbf.txt";